(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-shipping-info"] && !Shopify.designMode) return;
  try {
    (function () {
  // Recalculate "ships by" in the visitor's browser so a cached page never shows yesterday's date.
  function shipDate(days, cutoff, skipWeekends) {
    var d = new Date();
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    var isWeekend = function (x) { var w = x.getDay(); return w === 0 || w === 6; };
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipWeekends && isWeekend(d)) continue;
      added++;
    }
    while (skipWeekends && isWeekend(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-aa-ship-info]').forEach(function (el) {
      var out = el.querySelector('[data-aa-ship-date]');
      if (!out) return;
      var date;
      var fixed = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.dataset.fixedDate || '');
      if (fixed) {
        // Pre-sale: a fixed calendar date (built as a local date so it never shifts a day).
        date = new Date(+fixed[1], +fixed[2] - 1, +fixed[3]);
      } else {
        date = shipDate(
          parseInt(el.dataset.days, 10) || 0,
          parseInt(el.dataset.cutoff, 10) || 24,
          el.dataset.skipWeekends === 'true'
        );
      }
      try {
        out.textContent = new Intl.DateTimeFormat(el.dataset.locale || undefined, { month: 'short', day: 'numeric' }).format(date);
      } catch (e) {}
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-star-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.aaStarRatingInit) return;
    window.aaStarRatingInit = true;

    // Smooth-scroll to the reviews section when it is on this page; otherwise the link opens its href.
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-aa-sr]');
      if (!link) return;
      var target;
      try {
        target = document.querySelector(link.dataset.target);
      } catch (e) {
        return;
      }
      if (!target) return;
      event.preventDefault();
      var offset = parseInt(link.dataset.offset, 10) || 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', link.dataset.target.charAt(0) === '#' ? link.dataset.target : location.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });

    // sync: copy the average + count from the reviews section on the page.
    function sync() {
      document.querySelectorAll('[data-aa-sr][data-sync]').forEach(function (link) {
        var source;
        try {
          source = document.querySelector(link.dataset.target);
        } catch (e) {
          return;
        }
        if (!source || !source.dataset.avg) return;
        var avg = parseFloat(source.dataset.avg) || 0;
        var count = parseInt(source.dataset.count, 10) || 0;
        var lang = link.dataset.lang || 'en';
        var word = link.dataset.label || (count === 1 ? link.dataset.one : link.dataset.many);
        var ratingText = new Intl.NumberFormat(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(avg);
        var countText = new Intl.NumberFormat(lang).format(count);
        var fill = link.querySelector('[data-aa-sr-fill]');
        var ratingEl = link.querySelector('[data-aa-sr-rating]');
        var countEl = link.querySelector('[data-aa-sr-count]');
        if (fill) fill.style.width = Math.min(avg, 5) * 20 + '%';
        if (ratingEl) ratingEl.textContent = ratingText;
        if (countEl) countEl.textContent = countText + ' ' + word;
        link.setAttribute('aria-label', ratingText + ' ' + link.dataset.of + ', ' + countText + ' ' + word);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
